import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { TaxReportService } from 'src/app/services/cashier/tax-report.service';
import { IonContent } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { TimeService } from 'src/app/services/time-service/time.service';

@Component({
  selector: 'app-tax-reports',
  templateUrl: './tax-reports.component.html',
  styleUrls: ['./tax-reports.component.scss'],
})
export class TaxReportsComponent implements OnInit {
  @ViewChild('Content') content: IonContent;
  @Input() navigationFromWinLoss: boolean;
  
  emailMeDisabled = false;
  searchDisabled = false;
  showTable = false;
  showHand = false;
  showNoResults = false;

  public toDate;
  public fromDate;
  public todayDate;

  hand: any[];
  history: any[];
  totalRecords: number = 0;
  totalRecordsDetails: number = 0;
  currentHandDetails: any;
  currentPage: number = 1;
  currentPageDetails: number = 1;
  maxPage: number = 1;
  maxPageDetails: number = 1;
  itemsPerPage = 25;
  dateRange: number;

  public startDate: any;
  public hideElements: boolean;

  public customer: CustomerModel;
  public description_text: string = "";

  public w2gConsent = null;

  constructor(
    public successMessageService: SuccessMessageService,
    public navigator: Navigator,
    protected config: ConfigService,
    private taxReportService: TaxReportService,
    private appLinksService: AppLinksService,
    public userSessionService: UserSessionService,
    public timeService: TimeService
  ) {
    const appConfigInfo = this.config.getConfig();
    this.description_text = appConfigInfo.tax_report_description || "";

    this.hideElements = false;

    this.userSessionService.getCustomer().subscribe(customer => {
      this.customer = customer;
      this.checkW2GConsent();
    });
  }

  ngOnInit() { 
    // this.dateRange = parseInt(this.config.getConfig()["FEATURE_DATE_RANGE"]) || 14;
    this.dateRange = 365;
  }

  calendarUpdate(event) {
    this.toDate = event.toDate;
    this.fromDate = event.fromDate;
    this.searchDisabled = event.search;
    this.successMessageService.clearMessage();
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();

    const today = new Date();
    const date = new Date();
    this.todayDate = today;

    this.startDate = new Date(date.setDate(date.getDate() - this.dateRange)); //set start date 2 weeks ago to dynamically add 2 weeks range
    this.toDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(today)); //setting today date fallback and initial value for 'To' data passed to webservices
    this.fromDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(date)); //'From' data passed to webservice
  }

  onSearch() {
    this.searchDisabled = true;
    this.showTable = false;
    this.currentPage = 1;

    this.getTaxReports(true);
  }

  onPageChange(event) {
    this.currentPage = event;

    this.getTaxReports(true);
  }

  onConfirmClicked(hand) {
    this.currentHandDetails = hand;
    this.currentPageDetails = 1;
    this.hideElements = true;

    this.onTaxReportConfirm();
  }

  onTaxReportConfirm() {
    this.taxReportService.callPostTaxConfirm(this.currentHandDetails).subscribe({
      next: (response) => {
        if (response.result == 1) {
          this.showHand = true;
          this.getTaxReportCall(false);
        }
      },
      error: (error) => {
        console.error("error reaching tax report confirm", error);
      }
    })
  }

  onSendEmailClicked(hand) {
    this.taxReportService.callPostSendTaxReport(hand).subscribe({
      next: (response) => {
        if (response.result == 1) {
          this.content.scrollToTop();
          this.emailMeDisabled = true;
          this.successMessageService.setMessage("A copy of your Tax Report(s) has been sent to: " + this.customer.email);
        }
      },
      error: () => {
        this.emailMeDisabled = false;
        this.successMessageService.clearMessage();
      }
    })
  }

  onTaxReportGenerate(hand) {
    const url = this.taxReportService.getTaxReportUrl(hand);
    this.appLinksService.openExternalPage(url);
    return false;
  }

  trackByAckDate(index, item) {
    return item.ackDate;
  }

  onViewGame(hand) {
    this.currentHandDetails = hand;
    this.currentPageDetails = 1;

    this.getHandHistoryDetails()
  }

  onPageChangeDetails(event) {
    this.currentPageDetails = event;

    this.getHandHistoryDetails();
  }

  getTaxReports(scrollUp: boolean) {
    this.successMessageService.clearMessage();

    this.showNoResults = false;
    this.showTable = false;

    this.getTaxReportCall(scrollUp);
  }

  getTaxReportCall(scrollUp: boolean) {
    this.taxReportService.callGetTaxReport(this.fromDate, this.toDate, this.currentPage).subscribe(
      (response) => {
        if (response.result == 1) {
          this.history = response.payload.page_data;
          this.totalRecords = response.payload.count;
          this.currentPage = Number(response.payload.page_no);
          this.maxPage = response.payload.total_pages;

          if (this.totalRecords > 0) {
            this.showTable = true;
            this.showNoResults = false;
          }
          else {
            this.showNoResults = true;
            this.showTable = false;
          }

          if (scrollUp) this.content.scrollToTop(335);
        }
      }
    )
  }

  getHandHistoryDetails() {
    this.successMessageService.clearMessage();

    this.taxReportService.callCasinoGameDetails(this.currentHandDetails.gameId, this.currentHandDetails.gameHost, this.currentHandDetails.connectionTime, this.currentHandDetails.disconnectionTime, this.currentPageDetails).subscribe(
      (response) => {
        if (response.result == 1) {
          this.hand = response.payload.response;
          this.totalRecordsDetails = response.payload.count;
          this.currentPageDetails = response.payload.current_page;
          this.maxPageDetails = response.payload.pages;
          this.showHand = true;

          this.content.scrollToTop();
        }
      }
    )
  }

  onBack = () => {
    if (this.showHand) {
      this.showHand = false;
      this.emailMeDisabled = false;
    }
    else {
      //Updating Back button if user navigated from Win/Loss component
      if (this.navigationFromWinLoss) {
        this.navigator.navigateTo('WinLossComponent');
      } else {
        this.navigator.back();
      }
    }
  }

  checkW2GConsent() {
    this.w2gConsent = !(null === this.customer.getCustomDataProperty('W2G_ELECTRONIC_MAIL_CONSENT')
    || undefined === this.customer.getCustomDataProperty('W2G_ELECTRONIC_MAIL_CONSENT') 
    || this.customer.getCustomDataProperty('W2G_ELECTRONIC_MAIL_CONSENT') == "false"
    || this.customer.getCustomDataProperty('W2G_ELECTRONIC_MAIL_CONSENT') == false);
  }
}
